import { Configuration, CustomerSelectionDto, ProductTypeDto, RoomTypeDto } from 'api'
import { httpMiddleware } from 'utilities/http-middleware'

const middleware = [httpMiddleware]

export const configuration = new Configuration({
  middleware,
  basePath: window.global.REACT_APP_API_URL,
})

export const hasSelection = (
  selections: CustomerSelectionDto[],
  productType: ProductTypeDto,
  roomType: RoomTypeDto
) => {
  return selections.some(
    (selection) => selection.roomId === roomType.id && selection.productTypeId === productType.id
  )
}
